import _jsx from "@babel/runtime/helpers/jsx";
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { DisclaimerText, Section } from 'reaxl';
import homeServicesConfig from '../homeServicesConfig';
import HomeServicesItemCard from '../HomeServicesItemCard';

/**
 *  Dealer home services content and button CTA
 *
 */
const HomeServices = /*#__PURE__*/memo(_ref => {
  let {
    className,
    imageWidth,
    headingClassName,
    contentClassName,
    heading,
    services,
    showHeader = true,
    customServiceContent,
    ...rest
  } = _ref;
  const {
    content: {
      heading: dhsHeading,
      disclaimer,
      disclaimerMoneyBack
    }
  } = homeServicesConfig;
  const hasMoneyBack = Array.isArray(services) ? services.includes('moneyBackGuarantee') : 'moneyBackGuarantee' in services;
  return /*#__PURE__*/React.createElement(Section, Object.assign({
    "data-cmp": "homeServices",
    className: clsx('display-grid', className),
    uiContext: "level-3",
    alignment: "left",
    heading: showHeader && (heading || dhsHeading),
    headingClassName: headingClassName
  }, rest), /*#__PURE__*/_jsx(HomeServicesItemCard, {
    className: contentClassName,
    imageWidth: imageWidth,
    services: services,
    customServiceContent: customServiceContent
  }), /*#__PURE__*/_jsx(DisclaimerText, {
    className: "margin-top-3"
  }, void 0, disclaimer), hasMoneyBack ? /*#__PURE__*/_jsx(DisclaimerText, {
    className: "margin-top-1"
  }, void 0, disclaimerMoneyBack) : null);
});
export default HomeServices;